import { useEffect, useState } from "react";
import { useNavigate, useParams } from "../../../node_modules/react-router-dom/dist/index";
import _ from "lodash";
import { useForm } from "react-hook-form";
import { FORGET_PASSWORD_CHANGE, fetchData } from "../../components/Service";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const ChangeForgotPassword = () => {
	const [showPassword, setShowPassword] = useState(true);
	const [showConfirmPassword, setShowConfirmPassword] = useState(true);
	const { cp_token } = useParams();
	const navigate = useNavigate();

	const {
		register,
		handleSubmit,
		watch,
		setValue,
		trigger,
		formState: { errors },
		reset,
	} = useForm({ mode: "onChange" });

	const checkToken = (cpToken) => {
		fetchData(FORGET_PASSWORD_CHANGE, "POST", { token: cpToken }, false, false, (res) => {
			if (res?.status_code == 400) {
				toast.success("Reset password link has been expired, please send new request");

				navigate("/");
			}
		});
	};

	const submitDetails = (data) => {
		data = { ...data, token: cp_token };

		fetchData(FORGET_PASSWORD_CHANGE, "POST", data, false, false, (res) => {
			if (res.status) {
				toast.success(res?.message);

				navigate("/");
			} else {
				toast.error(res?.message);
			}
		});
	};

	useEffect(() => {
		if (!cp_token) {
			navigate("/");
		} else {
			checkToken(cp_token);
		}
	}, [cp_token]);

	return (
		<div class="col-lg-12">
			<div class="card card-forum ">
				<div class="card-header usa-bg px-1">
					<div className="national-bg">
						<div className="row d-flex align-items-center ind1">
							<div className="col-lg-12">
								<h4 class="text-white d-flex mb-0 py-2">Set New Password</h4>
							</div>
						</div>
					</div>
				</div>
				<div class="card-body bg-white p-1">
					<div class="card mb-3">
						<div class="row g-0 align-items-stretch">
							<div class="col-xl-12">
								<div class="card-body h-100 p-1">
									<form className="login-register text-start mt-20 pb-30 needs-validation" onSubmit={handleSubmit(submitDetails)}>
										<div className="row justify-content-md-center">
											<div className="col-4 my-2 ">
												<label>
													New Password <span className="text-danger">*</span>
												</label>
												<div className="input-group">
													<input
														className={`form-control bg-transparent ${errors.new_password && "is-invalid"}`}
														maxLength={20}
														placeholder="New Password"
														type={!showPassword ? "text" : "password"}
														{...register("new_password", {
															required: {
																value: true,
																message: "New password is required.",
															},
															minLength: {
																value: 8,
																message: "New password must be at least 8 characters.",
															},
															pattern: {
																value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]/,
																message: "New password must contain one uppercase, lowercase letter, number, special characters.",
															},
														})}
														onPaste={(e) => {
															e.preventDefault();
															const pasted = e.clipboardData.getData("text").replace(/\s/g, "");
															setValue("new_password", pasted,{shouldValidate: true}); // ✅ this updates react-hook-form state
														  }}
														  onChange={(e) => {
															const cleaned = e.target.value.replace(/\s/g, "");
															setValue("new_password", cleaned,{shouldValidate: true}); // ✅ this updates react-hook-form state
															trigger("new_password"); 
														  }}
													/>
													<button type="button" className={`btn btn-outline-secondary ${errors.new_password && "is-invalid"}`} onClick={() => setShowPassword(!showPassword)}>
														{!showPassword ? <FaEyeSlash /> : <FaEye />}
													</button>
													{errors.new_password && <div class="invalid-feedback">{errors.new_password.message}</div>}
												</div>
											</div>
										</div>
										<div className="row justify-content-md-center">
											<div className="col-4 my-2 ">
												<label>
													Confirm Password <span className="text-danger">*</span>
												</label>
												<div className="input-group">
													<input
														className={`form-control bg-transparent ${errors.retype_password && "is-invalid"}`}
														maxLength={20}
														placeholder="Confirm Password"
														type={!showConfirmPassword ? "text" : "password"}
														{...register("retype_password", {
															required: {
																value: true,
																message: "Confirm password is required.",
															},

															validate: (val) => {
																if (watch("new_password") != val) {
																	return "Confirm password does not match.";
																}
															},
														})}
														onPaste={(e) => {
															e.preventDefault();
															const pasted = e.clipboardData.getData("text").replace(/\s/g, "");
															setValue("retype_password", pasted,{shouldValidate: true}); // ✅ this updates react-hook-form state
														  }}
														  onChange={(e) => {
															const cleaned = e.target.value.replace(/\s/g, "");
															setValue("retype_password", cleaned,{shouldValidate: true}); // ✅ this updates react-hook-form state
															trigger("retype_password"); 
														  }}
													/>
													<button
														type="button"
														className={`btn btn-outline-secondary ${errors.retype_password && "is-invalid"}`}
														onClick={() => setShowConfirmPassword(!showConfirmPassword)}
													>
														{!showConfirmPassword ? <FaEyeSlash /> : <FaEye />}
													</button>
													{errors.retype_password && <div class="invalid-feedback">{errors.retype_password.message}</div>}
												</div>
											</div>
										</div>
										<div className="d-block text-center my-3">
											<button className="btn btn-default hover-up m-auto" type="submit" name="login">
												Submit
											</button>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ChangeForgotPassword;
